import { Orientations } from '@/enums/products'

export const defaultState = Object.freeze({
  form: {
    [Orientations.womenbralette]: {
      size: {
        reference: null,
        label: null
      },
      design: {
        name: null,
        slug: null
      }
    },
    [Orientations.womenhipster]: {
      size: {
        reference: null,
        label: null
      },
      design: {
        name: null,
        slug: null
      }
    },
    firstName: '',
    lastName: '',
    email: '',
    password: null,
    promotionCode: '',
    isUser: false,
    prospectId: null,
    address: {
      streetType: '',
      street: '',
      floor: '',
      houseNumber: null,
      annex: '',
      houseNumberAddition: '',
      building: '',
      postalCode: '',
      city: '',
      region: ''
    }
  },
  addressConfirmed: false
})

export const SignupVariants = Object.freeze({
  freeSet: 'freeSet',
  combiSet: 'combiSet'
})

export const SignupVariantCookie = 'ota-signup-variant'
